import * as XLSX from 'xlsx';
import { Lead, User } from '../types';
import { AgentInfo } from './api';
import { getConnectedPhonesForAgents } from '../hooks/useWhatsAppStatus';
import { AgentUserRS } from './api';

export const exportLeadsToExcel = async (leads: Lead[], users: User[], agentUsers: AgentUserRS[], agents: AgentInfo[], filename: string = 'leads.xlsx') => {
  // Buscar telefones conectados para todos os agentes únicos
  const uniqueAgentIds = Array.from(new Set(leads.map(l => l.agentId).filter(Boolean)));
  const connectedPhones = await getConnectedPhonesForAgents(uniqueAgentIds);

  const data = leads.map(lead => {
    const assignedUser = users.find(u => u.id === lead.assignedTo);
    const assignedAgentUser = agentUsers.find(au => au.userId === lead.assignedTo);
    const assignedName = assignedUser?.name || assignedAgentUser?.userName || lead.assignedToName;
    const agentName = agents.find(a => a.id === lead.agentId)?.name ?? 'N/A';
    const agentPhone = connectedPhones[lead.agentId] || 'N/A';
    const observations = lead.observacoes?.map(o => o.comentario).join(', ') ?? 'N/A';

    return {
      'Nome': lead.name,
      'Telefone': lead.phoneNumber,
      'Qualidade': lead.leadQuality || 'N/A',
      'Status': getStatusLabel(lead.status),
      'Responsável': assignedName || 'Não atribuído',
      'Interessado': lead.interested,
      'Data de Criação': new Date(lead.creationTime.$date).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' }),
      'Resumo da IA': lead.resumeAI,
      'Observações': observations,
      'Nome do Agente': agentName,
      'Telefone do Agente': agentPhone || 'N/A',
    };
  });

  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();

  const colWidths = [
    { wch: 25 }, // Nome
    { wch: 15 }, // Telefone
    { wch: 10 }, // Qualidade
    { wch: 15 }, // Status
    { wch: 20 }, // Responsável
    { wch: 10 }, // Interessado
    { wch: 20 }, // Data de Criação
    { wch: 50 }, // Resumo da IA
    { wch: 25 }, // Observações
    { wch: 25 }, // Nome do Agente
    { wch: 18 }, // Telefone do Agente
  ];

  worksheet['!cols'] = colWidths;

  XLSX.utils.book_append_sheet(workbook, worksheet, 'Leads');
  XLSX.writeFile(workbook, filename);
};

const getStatusLabel = (status?: string) => {
  switch (status) {
    case 'novo':
      return 'Novo';
    case 'contato_inicial':
      return 'Contato Inicial';
    case 'qualificado':
      return 'Qualificado';
    case 'proposta':
      return 'Proposta';
    case 'negociacao':
      return 'Negociação';
    case 'fechado':
      return 'Fechado';
    case 'perdido':
      return 'Perdido';
    default:
      return 'N/A';
  }
};